import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { useDialog } from '../../shared/context';
import { Grid, Box, TextField } from '@mui/material';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const AlertReprovedDialogSlide = ({ handleConfirm, handleCancel, dialogData }) => {
  const reprovedDocumentDialog = useDialog('reprovedDocumentDialog');
  const [getCommets, setComments] = useState('');

  const handleInputChange = (e) => {
    setComments(e.target.value);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    getCommets.trim() !== '' && handleConfirm(getCommets, dialogData);
  };

  return (
    <Dialog
      open={reprovedDocumentDialog.isDialogOpen()}
      TransitionComponent={Transition}
      keepMounted
      onClose={reprovedDocumentDialog.closeDialog}
      aria-describedby="alert-dialog-slide-description"
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>{'Justifique sua avaliação'}</DialogTitle>
      <DialogContent>
        <Box p={2}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <TextField
                label="Justificativa"
                variant="outlined"
                id="reproved"
                name="reproved"
                fullWidth
                margin="normal"
                required
                value={getCommets}
                onChange={handleInputChange}
              />
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={handleCancel}>
          não
        </Button>
        <Button variant="outlined" onClick={handleFormSubmit}>
          sim
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AlertReprovedDialogSlide;
